import { useOrganizationData } from './useOrganizationData'
import { useAuthStore } from '@/stores/authStore'

/**
 * Returns the internal UUID of the current organization.
 *
 * The auth store holds the Kinde external org code (e.g. `org_xxx`), but
 * org-scoped API routes expect the internal UUID in the path parameter.
 * This hook resolves the mapping using the already-cached organization data
 * from `GET /api/auth/organizations`.
 */
export const useCurrentOrganizationId = (): string | undefined => {
	const externalId = useAuthStore((s) => s.currentOrganization?.organizationId)
	const organizations = useOrganizationData()

	if (!externalId) return undefined

	return organizations.find((o) => o.externalId === externalId)?.id
}
